module.exports = function ($stateProvider) {
    $stateProvider // Recipes
        .state('shop.search.recipes', {
            url: '/recipes',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-search-recipe-tile-list
                            search-term="$ctrl.$state.params.searchTerm"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-search-recipe-tile-list>
                    `,
                },
            },
        })
        .state('shop.search.articles', {
            url: '/articles',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-search-inspiration-tile-list
                            search-term="$ctrl.$state.params.searchTerm"
                            page-number="$ctrl.$state.params.pageNumber || 1">
                        </wow-search-inspiration-tile-list>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/search-child-routes.js